import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { startCase, toLower } from 'lodash';
import './BeneficiaryDataCardBody.scss';
import { formatStringIfEducationSavings, renderDesignationHeader } from 'services/BeneficiaryV2';
import BeaconNotification from 'components/shared/BeaconNotification/BeaconNotification';

const BeneficiaryDataCard = ({ beneficiary, index }) => {
    const { name, relationshipName, distributionAmountFormated } = beneficiary;

    return (
        <div key={index} className="b-grid-item--12-col beneficiary-row">
            <div className="b-grid-item--12-col beneficiary-info">
                <div className="b-grid-item--4-col beneficiary-name">
                    <span className="b-typography-sans-serif--body--200 b-font-weight-light blocked_data"> {name}</span>
                </div>
                <div className="b-grid-item--4-col beneficiary-relationship">
                    <span className="b-typography-sans-serif--body--100 b-font-weight-light blocked_data">{startCase(toLower(relationshipName))}</span>
                </div>
            </div>
            <div className="b-grid-item--4-col beneficiary-distribution">
                <span className="b-typography-sans-serif--body--200 b-font-weight-bold">{distributionAmountFormated}%</span>
            </div>
        </div>
    );
}

const BeneficiaryDataCardBody = ({
    className = '',
    beneficiaries,
    pendingText,
    isEsa,
    isIndividual,
    isJoint,
}) => {
    const { primary, secondary } = beneficiaries;
    if (isIndividual || isJoint) {
        return (
            <div className="no-beneficiaries-wrapper">
                <div className="no-beneficiaries">
                    In order to name beneficiaries, this account must be updated to be a Transfer on Death (TOD) account.
                </div>
            </div>
        );
    }
    if (beneficiaries.beneficiaryCount === 0) {
        return (
            <div className="no-beneficiaries-wrapper">
                <div className="no-beneficiaries">{
                    formatStringIfEducationSavings("You have not named any beneficiaries yet.", isEsa)}
                </div>
            </div>
        );
    }

    return (
        <Fragment>
            <div className={className}>
                {pendingText && (
                    <BeaconNotification
                        title={"Updates Pending"}
                        variant="informational"
                        type="inline"
                        description={pendingText}
                    />
                )}
                {primary.length > 0 && (
                    <Fragment>
                        <div className="beneficiary-header">
                            <h3 className="b-typography-sans-serif--headline--50 b-font-weight-bold">{renderDesignationHeader(isEsa)}</h3>
                        </div>
                        <div className="beneficiary-row-group">
                            {primary.map((beneficiary, index) => <BeneficiaryDataCard beneficiary={beneficiary} index={index} key={index} />)}
                        </div>
                    </Fragment>
                )}
                {secondary.length > 0 && (
                    <Fragment>
                        <div className="beneficiary-header">
                            <h3 className="b-typography-sans-serif--headline--50 b-font-weight-bold">Secondary beneficiaries</h3>
                        </div>
                        <div className="beneficiary-row-group">
                            {secondary.map((beneficiary, index) =>
                                <BeneficiaryDataCard beneficiary={beneficiary} index={index} key={index} />
                            )}
                        </div>
                    </Fragment>
                )}
            </div>
        </Fragment>
    );
};

BeneficiaryDataCardBody.propTypes = {
    className: PropTypes.string,
    beneficiaries: PropTypes.shape({
        primary: PropTypes.arrayOf(
            PropTypes.shape({
                name: PropTypes.string.isRequired,
                distributionAmount: PropTypes.number.isRequired
            })
        ).isRequired,
        secondary: PropTypes.arrayOf(
            PropTypes.shape({
                name: PropTypes.string.isRequired,
                distributionAmount: PropTypes.number.isRequired
            })
        ).isRequired,
        isEmpty: PropTypes.bool.isRequired
    }).isRequired
};

export default BeneficiaryDataCardBody;